export function setCanonicalUrlDomUtil (url) {
  let canonicalLink = document.querySelector('link[rel="canonical"]')
  if (
    !url &&
    canonicalLink
  ) {
    canonicalLink.parentNode.removeChild(canonicalLink)
    return
  }

  if (!url) {
    return
  }

  if (!canonicalLink) {
    canonicalLink = document.createElement('link')
    canonicalLink.setAttribute('rel', 'canonical')
  }

  canonicalLink.setAttribute('href', url)
}
